<template lang="pug">
  .row
    .col-md-6
      slot(name='left')
    .col-md-6
      .description
        h3(v-html='title')
        br
        markdown(:source='source')
        .row.actions
          .col-6
            b-button.btn-block(variant='cancel' @click='cancel') {{ $t('pos.format.modal.cancel') }}
          .col-6
            b-button.btn-block(
              variant='success'
              :data-confirm-format='type ? type : null'
              @click='confirm'
            ) {{ $t('pos.format.modal.confirm') }}
</template>

<script>
import markdown from '@/components/markdown/Markdown.vue';

export default {
  components: {
    markdown,
  },
  props: {
    title: String,
    source: String,
    type: {
      type: String,
      default: null,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>



// WEBPACK FOOTER //
// CampaignFormatPopup.vue?b7018672